<template>
  <div class="wapper">
    <el-container>
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.phone"
                      placeholder="手机"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.code"
                      placeholder="码值"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-select
                      placeholder="投票类型："
                      v-model="searchForm.voteId"
                      class="el-input-position"
                      v-on:change="getChange"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                        v-for="(item, index) in voteList"
                        :key="index"
                        :label="item.name"
                        :value="item.voteId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-select
                      placeholder="投票项目："
                      v-model="searchForm.voteItemId"
                      class="el-input-position"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                        v-for="(item, index) in voteItemList"
                        :key="index"
                        :label="item.name"
                        :value="item.voteItemId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-date-picker
                      v-model="searchForm.startDate"
                      type="datetime"
                      style="width: 200px"
                      placeholder="开始日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label>
                  <el-date-picker
                      style="width: 200px"
                      v-model="searchForm.endDate"
                      type="datetime"
                      placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit()"
                >搜索
                </el-button
                >
                <el-button
                    type="primary"
                    icon="el-icon-export"
                    @click="exportExcel()"
                >导出
                </el-button
                >
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="name"
                  width="120"
                  label="姓名"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="phone"
                  width="120"
                  label="手机"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.phone }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="idCard"
                  width="150"
                  label="人员编号"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.code }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  width="120"
                  label="投票类型"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.vote }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  width="120"
                  label="投票项目"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.voteItem }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  width="150"
                  label="创建时间"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import DeleteDialog from "../../components/public/DeleteConfim";

export default {
  data() {
    return {
      fileList: [],
      qrcode: '',
      dialogVisible: false,
      gb: window.location.href.indexOf('/gb') > 0,
      total: 0, //总条数
      currentPage: 1, //初始页
      pageSize: 10, // 每页的数据
      searchForm: {
        voteId: "0",
        voteItemId: "0",
        name: "",
        phone: "",
        code: "",
        projectId: localStorage.getItem("project_Id"),
        endDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 - 1
        ),
        startDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() -
            (new Date(new Date().toLocaleDateString()).getTime() -
                new Date(new Date().getFullYear().toString()))
        ),
      },
      voteList: [],
      voteItemList: [],
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
    };
  },
  created() {
    this.getData();
    this.loadData();
  },
  methods: {
    getChange() {
      this.$axios.post("/VoteItem/Search", {type: this.searchForm.voteId}).then((res) => {
        if (res.data.hasError == false) {
          this.voteItemList = [...res.data.data];
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    loadData() {
      this.$axios.post("/Vote/Search", {projectId: this.projectId}).then((res) => {
        if (res.data.hasError == false) {
          this.voteList = [...res.data.data];
        }
      });
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post(`/VoteRecord/Export`, this.searchForm)
          .then((res) => {
            loading.close();
            if (res.data.data) {
              window.open(res.data.data, '_self');
              // this.$download(res.data.data, '导出证件.xlsx');
            } else {
              this.$message.error("导出不通过");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出不通过");
          });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    addSubmit() {
      this.voteRecordId = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    handleDelete(index, row) {
      this.voteRecordId = row.voteRecordId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.voteRecordId = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios.delete(`/VoteRecord/${this.voteRecordId}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    // 获取数据
    getData() {
      this.searchForm.pageSize = this.pageSize;
      this.searchForm.pageIndex = this.currentPage - 1,
          this.$axios.post("/VoteRecord/Search", this.searchForm).then((res) => {
            if (res.data.hasError == false) {
              this.dataList = [...res.data.data];
              this.total = res.data.total;
            }
          });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  }
  ,
  components: {
    DeleteDialog,
  }
  ,
}
;
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.qr-code {
  text-align: center;
  vertical-align: center;
  margin-top: 20px;
  background-color: #fff;
}

.flex-box {
  text-align: center;
  vertical-align: center;
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
  margin: 10px 10px 10px 10px;
}

.uers-import {
  margin-right: 30px;
  float: right;
  width: 240px;
}

.upload-excel {
  float: left;
}

.import-bnt {
  float: right;
}

.el-upload {
  height: 32px !important;
  line-height: 32px !important;
  width: 120px !important;
}

.el-upload--text {
  border: 0;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}
</style>